import IFrameLoaderPresenter from "../components/iframe-loader/presenter/iframe-loader.js";

const elements = document.querySelectorAll(`iframe`);

if (elements) {
  const iFrameLoaderComponent = new IFrameLoaderPresenter(elements);
  iFrameLoaderComponent.init();
}
